import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { HeadMeta } from '@packages/shared';
import { ProductSeoFragmentDoc } from '@packages/gql/generated/shopping/ProductSeoFragmentDoc';
import { SchemaOrg } from '../SchemaOrg';
import { getEuroFromCentValue } from '../../helpers/getEuroFromCentValue';

/* GraphQL */ `
  fragment ProductSeo on Product {
    name
    price {
      value
      currency
    }
    media {
      url
    }
    productHeadSeo: seo(locale: $locale) {
      title
      description
      canonicalUrl
      keywords
      robots
    }
    ...SchemaOrgFragment
  }
`;

interface ProductPageHeadProps {
  data: FragmentType<typeof ProductSeoFragmentDoc>;
}

export const ProductPageHead = ({ data }: ProductPageHeadProps) => {
  const product = getFragmentData(ProductSeoFragmentDoc, data);
  const { name, price, media, productHeadSeo } = product;
  const title =
    productHeadSeo && productHeadSeo.title
      ? productHeadSeo.title.replace('{ProductName}', name)
      : undefined;
  const description =
    productHeadSeo && productHeadSeo.description
      ? productHeadSeo.description.replace('{ProductName}', name).replace(/"/g, '&quot;')
      : undefined;
  return (
    <HeadMeta
      meta={{
        title,
        robots: productHeadSeo?.robots ?? undefined,
        keywords: productHeadSeo?.keywords ?? undefined,
        description,
      }}
      links={{
        canonical: productHeadSeo?.canonicalUrl ?? undefined,
      }}
      schemaorg={SchemaOrg({ productData: product })}
      socialMeta={{
        image: media?.length > 0 ? media[0].url : undefined,
        title,
        description,
        type: 'product',
        price: getEuroFromCentValue(price.value).toString(),
        currency: price.currency,
      }}
    />
  );
};
